export const ROUTES_CYCLES_CONFIG = {
  route: {
    key: "route",
    label: "Ruta"
  },
  paymentCycle: {
    key: "collectPeriod",
    label: "Periodo de Cobro"
  },
  facility: {
    key: "facilityName",
    label: "Edificio"
  },
  employee: {
    key: "employee",
    label: "Empleado"
  },
  cycle: {
    key: "cycle",
    label: "Ciclo"
  },
  start: {
    key: "start",
    label: "Inicio"
  },
  end: {
    key: "end",
    label: "Fin"
  },
  status: {
    key: "status",
    label: "Estado"
  }
};

export const ROUTES_CYCLES_PHRASE = {
  page: {
    table: {
      title: "Catalogo de Periodos de Corte"
    }
  },
  modal: {
    titles: {
      edit: "Modificar Periodo de Corte",
      add: "Agregar Nuevo Periodo de Corte",
      delete: "¿Estas seguro de eliminar este periodo de corte?"
    },
    actions: {
      cancel: "Cancelar",
      add: "Agregar",
      delete: "Eliminar",
      save: "Guardar",
      submit: "Aceptar"
    },
    content: {
      open: "¿Estas seguro que desea abrir el periodo de corte?"
    }
  },
  search: {
    messages: {
      noStations: "No se ha seleccionado alguna planta.",
      opened: "Periodo de corte abierto"
    }
  },
  form: {
    dropdowns: {
      route: "Seleccione una Ruta",
      paymentCycle: "Seleccione una Periodo de Cobro",
      employee: "Seleccione un Empleado",
      status: "Seleccione un Estado"
    }
  }
};
